import modelBase from '../../models/model-base.model';
import modelBaseV2 from '../model-base-v2.model';

const workTemplateModel = {
  getWorkTemplateList: function (successCallBack, failureCallBack, filter) {
    let urlParams = "?WorkType=" + filter.selectedWorkType + "&WorkTemplateName=" + filter.name + "&WorkTemplateStatus=" + filter.status + "&PageIndex=" + filter.pageIndex + "&PageSize=" + filter.pageSize;
    modelBase.get(successCallBack, failureCallBack, '/api/schedule/workTemplate' + urlParams);
  },

  getWorkTypeList: function (successCallBack, failureCallBack) {
    modelBase.get(successCallBack, failureCallBack, '/api/codemaster/WorkType');
  },

  getSpecIalTaskTypeList : function () {
    return modelBaseV2.get('/api/codemaster/SpecialTaskType');
  },

  saveWorkTemplate: function (successCallBack, failureCallBack, filter) {
    modelBase.post(successCallBack, failureCallBack, '/api/schedule/worktemplate/create', { body: filter });
  },

  updateWorkTypeList: function (successCallBack, failureCallBack, filter, masterId) {
    modelBase.post(successCallBack, failureCallBack, '/api/schedule/worktemplate/edit/' + masterId, { body: filter });
  },

  changeStatusOfWorkType: function (successCallBack, failureCallBack, masterId, status) {
    modelBase.post(successCallBack, failureCallBack, '/api/schedule/worktemplate/statusupdate/' + masterId + '/' + status, { body: {} });
  },

  getDayoffList: function (successCallBack, failureCallBack) {
    modelBase.get(successCallBack, failureCallBack, '/api/codemaster/DayOffType');
  },

  getLeaveTypeList: function (successCallBack, failureCallBack) {
    modelBase.get(successCallBack, failureCallBack, '/api/codemaster/LeaveType');
  },

  getWorkTemplateDetail: function (successCallBack, failureCallBack, id) {
    modelBase.get(successCallBack, failureCallBack, '/api/schedule/workTemplate/' + id);
  }
}

export default workTemplateModel;
